import PropTypes from 'prop-types';

import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const InputModalForm = ({ 
  title, label, show, setShow, value, setValue, formErrors, 
  errorKey, handleSubmit 
}) => {
  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={show}>
        <Box sx={style} component="form" onSubmit={handleSubmit}>
          <Box>
            <Typography id="transition-modal-title" variant="h5" component="h3">
              <strong>{title}</strong>
            </Typography>
          </Box>
          
          <Box sx={{ marginTop: 1.5 }}>
            <TextField
              id="outlined-multiline-flexible"
              label={label}
              fullWidth
              value={value}
              onChange={e => setValue(e.target.value)}
              helperText={formErrors[errorKey]}
              error={errorKey in formErrors}
            />
          </Box>

          <Box sx={{ marginTop: 1.5 }}>
            <Button
              variant='contained'
              color='success'
              type="submit"
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

InputModalForm.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  formErrors: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default InputModalForm;